import { View, Text } from "react-native";
import React from "react";
import { white } from "../../colors";

export default function ProgressBar({ progress, color }) {
  return (
    <View
      style={{
        height: 10,
        borderRadius: 15,
        alignItems: "center",
        flexDirection: "row",
        width: "100%",
        backgroundColor: white,
        overflow: "hidden",
      }}
    >
      <View
        style={{
          backgroundColor: color,
          width: `${
            progress > 100 || progress === undefined ? 100 : progress
          }%`,
          height: 10,
          borderRadius: 15,
          borderWidth: 1,
          borderColor: white,
        }}
      ></View>
    </View>
  );
}
